'use client';

import type { ProductDiscount } from '@/types';

import React from 'react';

import { Box, Button, Container, Image, Link, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const Promotion: React.FC<{ promotions: ProductDiscount[] }> = ({
  promotions,
}) => {
  const { t } = useTranslation('pages.home');

  return (
    <Container py={{ base: 5, md: 2.5 }}>
      <Stack gap={4}>
        {promotions.map((data) => (
          <Box
            display="flex"
            justifyContent="center"
            flexDir={{ base: 'column', md: 'row' }}
            key={data.id}
            bg="gray.250"
            borderRadius="xs"
            gap={2.5}
            as={Link}
            href={routes.promotions.href(data.code)}
            prefetch={false}
          >
            <Box
              display={{ base: 'block', md: 'none' }}
              position="relative"
              width="100%"
              borderRadius="xs"
              overflow="hidden"
              sx={{
                img: {
                  borderRadius: '8px',
                },
              }}
            >
              <Image
                src={data.preview_image}
                alt={data.title}
                width={705}
                height={478}
              />
            </Box>
            <Box
              w={{ base: '100%', md: '50%' }}
              p={6}
              display="flex"
              justifyContent="center"
              flexDir="column"
              gap="44px"
            >
              <Text fontWeight={700} fontSize="34px">
                {data.title}
              </Text>
              <Text fontWeight={400} fontSize="md" lineHeight="37px" mt="-4">
                {data.description}
              </Text>
              <Button variant="outline">{t('readMore')}</Button>
            </Box>
            <Box
              display={{ base: 'none', md: 'block' }}
              position="relative"
              width="50%"
              overflow="hidden"
              sx={{
                img: {
                  borderRadius: '8px',
                },
              }}
            >
              <Image
                src={data.preview_image}
                alt={data.title}
                width={705}
                height={478}
              />
            </Box>
          </Box>
        ))}
      </Stack>
    </Container>
  );
};
export default Promotion;
